import { render, staticRenderFns } from "./TraxUiCheckbox.vue?vue&type=template&id=2dea7887"
import script from "./TraxUiCheckbox.vue?vue&type=script&lang=js"
export * from "./TraxUiCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports